module.exports = __webpack_public_path__ + "static/media/dryer-alt.e214d8c7.svg";